<template>
  <div>
    <div class="md-container md-effect-10" id="clientsLoader">
      <div class="md-content">
        <div class="modal-body">
          <div class="mdl-card">
            <div class="mdl-card__title">
              {{ t("Loading Clients...") }}
            </div>
            <div>
              Loaded <span id="loaded-clients">0</span> /
              <span id="total-clients">0</span>
            </div>
            <div style="padding-top:10px;" class="mdl-card__supporting-text">
              <div
                style="text-align:center;padding-top:5px;"
                id="p2"
                class="mdl-progress mdl-js-progress mdl-progress__indeterminate"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="md-overlay"></div>
  </div>
</template>

<script>
import "jquery.niftymodals/dist/jquery.niftymodals.css";
require("jquery.niftymodals/dist/jquery.niftymodals.js");
export default {};
</script>

<style lang="scss" scoped>
#clientsLoader {
  & > .md-content {
    .mdl-card {
      min-height: auto;
      padding: 60px 0;
      .mdl-card__title {
        justify-content: center;
        text-transform: capitalize;
      }
    }
  }
}
.md-content {
  max-width: 400px;
  .modal-body {
    height: 100%;
    overflow: hidden;
    .mdl-card {
      display: block;
      max-width: 100%;
      height: 100%;
      & .mdl-card__title {
        color: #009fde;
        margin-bottom: 10px;
        padding: 0;
        font-size: 23px;
      }
      .mdl-card__supporting-text {
        height: 100%;
        width: 100%;
        padding: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ClientsLoader.vue